import React, { useEffect, useRef } from 'react';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Input.module.scss';

type Props = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  name: string;
  required?: boolean;
  placeholder?: string;
  focusEffect?: any;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleDelete?: () => void;
  variant?: 'default' | 'underline';
  icon?: React.ReactNode;
};

export default function Input({
  value,
  onChange,
  name,
  required = true,
  placeholder = '',
  focusEffect,
  onKeyDown,
  handleDelete,
  variant = 'default',
  icon,
}: Props) {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focusEffect) ref.current?.focus();
  }, [focusEffect]);

  return (
    <div styleName="wrapper">
      <input
        type={
          name === 'email'
            ? 'email'
            : name.includes('password')
            ? 'password'
            : 'text'
        }
        style={{
          paddingRight: handleDelete || icon ? '2.5rem' : 0,
          borderRadius: name.includes('search') ? '100px' : '',
        }}
        ref={ref}
        name={name}
        onChange={onChange}
        value={value}
        required={required}
        onKeyDown={onKeyDown}
        styleName={`input ${variant}`}
        placeholder={placeholder}
      />
      {icon && <div styleName="icon-wrapper">{icon}</div>}
      {!!handleDelete && (
        <div styleName="delete" onClick={handleDelete}>
          <FontAwesomeIcon icon={faTimes} />
        </div>
      )}
    </div>
  );
}
